<div class="spacer" [class.collapsed]="collapsed()"></div>
<div
  class="sidebar flex flex-col h-full shadow-lg shadow-gray-300"
  [class.collapsed]="collapsed()">
  @if (!collapsed()) {
    <div class="collapser"><i class="pi pi-caret-left" (click)="setCollapsed(true)"></i></div>
  }@else{
    <div class="expander"><i class="pi pi-caret-right" (click)="setCollapsed(false)"></i></div>
  }
  <div routerLink="/" class="logo" [class.collapsed]="collapsed()"></div>
  <div class="menu flex-1 flex flex-col overflow-hidden w-[290px]">
    <p-scroll-panel class="flex-1 flex overflow-hidden" styleClass="w-[300px]">
      <app-side-menu class="overflow-hidden" />
    </p-scroll-panel>
    <div class="profile" routerLink="/profile"><i class="pi pi-user mr-4"></i>{{ currentUser().email }}</div>
  </div>
</div>
